module.exports = "/assets/data/a638dd186e1055944d044f519dac393d-AL7.data.json";